import { Dialog } from "primereact/dialog"
import { IDropdown, IHotel } from "../../models/BaseModel"
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Checkbox } from "primereact/checkbox";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

interface Iprops {
    open: boolean,
    hideDialog: () => void,
    hotel: IHotel,
    toast: any
}

export const HotelAminites = (props: Iprops) => {
    const [amenities, setAmenities] = useState<IDropdown[]>();
    const [intialAmenities, setInitialAmenities] = useState<IDropdown[]>();
    const [selectedAmenities, setSelectedAmenities] = useState<IDropdown[]>();
    const [valueChanged, setValueChanged] = useState(false);
    const [loading, setLoading] = useState(false);

    const loadAmenities = async (amenityType: string) => {
        const response = await Fetch(`amenity/dropdown/${amenityType}`, "GET", null, null, props.toast);
        if (response) {
            setAmenities(await response.json());
        }
    }
    const loadAssignedAmenities = async (hotelId: number) => {
        setLoading(true);
        const response = await Fetch(`amenity/hotel/${hotelId}`, "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setInitialAmenities(data);
            setSelectedAmenities(data);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.hotel.id) {
            loadAssignedAmenities(props.hotel.id);
        }
    }, [props.hotel.id]);

    useEffect(() => { loadAmenities('Hotel'); }, []);

    const onHideDialog = () => {
        props.hideDialog();
        setSelectedAmenities(undefined);
        setInitialAmenities(undefined);
        setValueChanged(false);
    }

    const reset = () => setSelectedAmenities(intialAmenities);


    const handleSelectAll = () => {
        confirmDialog({
            message: 'Are you sure you want to select all amenities?',
            header: 'Confirm Select All',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => {
                setSelectedAmenities(amenities);
                if (!valueChanged) setValueChanged(true);
                props.toast.current.show({ severity: 'success', summary: 'Success', detail: 'All amenities selected successfully!', life: 3000 });
            },
            reject: () => {
                props.toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Select all action was cancelled.', life: 2000 });
            }
        });
    };


    const handleClearsAll = () => {
        confirmDialog({
            message: 'Are you sure you want to clear all amenities?',
            header: 'Confirm Clear All',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => {
                setSelectedAmenities([]);
                if (!valueChanged) setValueChanged(true);
                props.toast.current.show({ severity: 'success', summary: 'Success', detail: 'All amenities Clear successfully!', life: 3000 });

            },
            reject: () => {
            }
        });
    };

    const onCheckChange = (a: IDropdown, selected: boolean) => {
        if (!valueChanged) setValueChanged(true);
        if (selected) {
            setSelectedAmenities(prev => (prev?.filter(_a => _a.id !== a.id)));
        } else {
            setSelectedAmenities(prev => ([...prev ?? [], a]));
        }
    }

    const saveToDB = async () => {
        setLoading(true);

        props.hotel.amenityIds = selectedAmenities?.map(a => a.id);

        const response = await Fetch(`hotel/${props.hotel.id}`, 'PUT', props.hotel, null, props.toast);
        if (response) {
            setValueChanged(false);
            props.toast.current.show({ severity: 'success', detail: 'Updated Successfull', life: 3000 });
        }
        setLoading(false);
    }


    return (
        <>
            {/* <ConfirmDialog /> */}
            <Dialog visible={props.open} style={{ width: '80vw' }}
                header={`Aminities : ${props.hotel.name} (${props.hotel.cityName} | ${props.hotel.stateName} | ${props.hotel.countryName})`}
                footer={
                    valueChanged && <>
                        <Button style={{ width: '100px' }} label="SELECT ALL" disabled={loading} onClick={handleSelectAll} className="p-button-sm p-button-rounded p-button-outlined surface-200"></Button>
                        <Button style={{ width: '100px' }} label="CLEAR ALL" disabled={loading} onClick={handleClearsAll} className="p-button-sm p-button-rounded p-button-outlined surface-200"></Button>
                        <Button style={{ width: '100px' }} label="RESET" disabled={loading} onClick={reset} className="p-button-sm p-button-rounded p-button-outlined surface-200"></Button>
                        <Button onClick={saveToDB} style={{ width: '100px' }} loading={loading} label="SAVE" className="p-button-sm p-button-rounded"></Button>
                    </>
                }
                modal className="p-fluid" onHide={onHideDialog}>
                {selectedAmenities === undefined ? 'Loading...'
                    : <div className="flex flex-wrap gap-2 mt-2 ml-4">
                        {amenities?.map(a => {
                            const selected = selectedAmenities.find(_a => _a.id === a.id) ? true : false;
                            return <div key={a.id} className="flex items-center">
                                <Tag style={{ width: '200px', backgroundColor: selected ? '#22c55e' : '#64748b' }} className="mr-2 py-2 px-3 cursor-pointer"
                                    icon={selected ? 'pi pi-check-circle' : undefined}
                                    value={a.name}
                                    onClick={() => onCheckChange(a, selected)}>
                                </Tag>
                            </div>
                        })}
                    </div>}
            </Dialog>
        </>
    )
}